module.exports = __webpack_public_path__ + "img/banner2.ebeb5fba.jpg";